export const ActionTypes = {
	ACTION: "Action"
};